import { createFileRoute } from '@tanstack/react-router';

import { DashboardUnavailableMessage } from 'component/view/Redirects/DashboardUnavailableMessage';

export const Route = createFileRoute('/n/dashboard-unavailable-message')({
  component: DashboardUnavailableMessage,
});
